<template>
  <div v-if="model" class="query-result" :class="{ 'query-result-599': shouldShowMedicalRecord, 'query-result-henan-special': isHenanSpecialType }">
    <div class="query-result-content">
      <div class="query-result-content-top">
        <div class="query-result-content-top-header" :class="{ 'with-logo': shouldShowHospitalLogo }">
          <img 
            v-if="shouldShowHospitalLogo" 
            src="https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/file/file-read-8683-河南.jpg" 
            alt="河南省儿童医院logo" 
            class="hospital-logo"
          />
          <p class="query-result-content-top-title" :class="{ 'title-small': isHenanSpecialType }">{{ displayTitle }}</p>
        </div>
        <div class="query-result-content-top-buttons" v-if="showControl">
          <edit-button v-if="shouldShowEditableFields" :inputIsEditable="isEditable" @onEdit="onEdit" @onSave="onSave" class="noPrint edit-button-top"></edit-button>
          <button class="noPrint" @click="onDownloadPNG">下载PNG</button>
          <button class="noPrint" @click="onDownloadPDF">下载PDF</button>
          <button class="noPrint" @click="onPrint">打印</button>
        </div>
      </div>
      <section-title title="基本信息" />
      
      <div v-if="shouldShowEditableFields && isEditable" class="query-result-content-editable">
        <div class="query-result-content-editable-row">
          <key-unit-input title="姓名" v-model="editableName"></key-unit-input>
          <div class="key-unit gender-select-unit">
            <p class="key-unit-key">性别：</p>
            <div class="key-unit-content">
              <el-select v-model="editableGender" placeholder="请选择性别">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </div>
          </div>
          <key-unit-date-picker title="出生日期" v-model="editableBirthday" :picker-options="pickerOptions"></key-unit-date-picker>
        </div>
        <div class="query-result-content-editable-row">
          <key-unit-input title="病案号" v-model="editableMedicalRecordNumber" class="medical-record-input"></key-unit-input>
        </div>
      </div>
      
      <div v-else class="query-result-content-basis" :class="{ 'query-result-content-basis-mr': shouldShowMedicalRecord }">
        <unit title="姓名" :value="model.name"></unit>
        <unit title="性别" :value="model.sex"></unit>
        <unit title="年龄" :value="shouldShowMedicalRecord ? calculatedAge : model.age"></unit>
        <unit v-if="shouldShowBirthday" title="出生日期" :value="model.model.birthday ? formatBirthday(model.model.birthday) : ''"></unit>
        <unit v-if="!shouldShowMedicalRecord" title="测评时间" :value="model.assessmentTime"></unit>
      </div>
       <div v-if="shouldShowMedicalRecord && !isEditable" class="query-result-content-basis">
        <unit title="病案号" :value="model.medicalRecordNumber"></unit>
        <unit title="测评时间" :value="model.assessmentTime"></unit>
      </div>
      <section-title v-if="showScore" title="评估结果" />
      <result v-if="showScore" :model="model"></result>
      <psq-table v-if="shouldShowMedicalRecord && model.type === 13" :model="model"></psq-table>
      <query-table v-else :model="model.tableData" :two-column="shouldUseTwoColumnTable"></query-table>
      <div v-if="shouldPaging" style="page-break-after: always"></div>
      <bar-chart v-if="showScore" class="query-result-content-bar-chart" :model="model.chartData" :height-factor="isHenanSpecialType ? 45 : 50"></bar-chart>
      <!-- <div v-if="shouldPagingAfterChart" style="page-break-after: always"></div> -->
      <!-- PSQ专用结果分析和量表说明 -->
      <template v-if="shouldShowMedicalRecord && model.type === 13">
        <section-title title="结果分析" />
        <p class="query-result-content-suggestion psq-suggestion">本次测试结果为{{ getPsqTotalScore() }}，请结合临床及其他辅助检查结果考虑，具体情况请向医生进行咨询。</p>

      <section-title title="量表说明" />
        <p class="query-result-content-suggestion">本量表由Chervin等人开发，是美国儿科学会2012年OSAS指南中唯一推荐的问卷。其内容涵盖打鼾、呼吸暂停、张口呼吸、口干、尿床、日间嗜睡等，敏感性特异性超过80%。本量表包括以下因子：<br/>
        • 呼吸：包括打鼾、呼吸困难、呼吸费力、呼吸停止、张口呼吸、口干、晨起头痛。<br/>
        • 嗜睡：包括小朋友自己、老师或其他看护人发现小朋友总爱睡觉。<br/>
        • 行为：包括心不在焉、较难安排活动或任务、注意力不集中、多动等。<br/>
        • 其他：包括尿床、晨起时感觉未得到充分体息、早上很难叫醒、曾有过生长发育停滞、超重。</p>
      </template>
      <template v-else-if="model.type === 46">

      </template>
      
      <!-- 其他情况的指导意见 -->
      <template v-else>
        <section-title v-if="showScore" title="指导意见" />
        <p v-if="showScore" class="query-result-content-suggestion" v-html="model.suggestion"></p>
      </template>
      
      <!-- 河南省儿童医院专用底部信息 -->
      <div v-if="shouldShowMedicalRecord" class="query-result-content-footer">
        <p>科室：耳鼻咽喉头颈外科</p>
        <p>报告医生：刘玉洁</p>
        <p>日期：{{ model.assessmentTime }}</p>
      </div>
      <div v-if="shouldShowReference" class="query-result-content-reference">
        <p>本报告只作为参考</p>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "@c/query-result/section-title.vue";
import Unit from "@c/query-result/unit.vue";
import Result from "@c/query-result/result.vue";
import QueryTable from "@c/query-result/query-table.vue";
import PsqTable from "@c/query-result/psq-table.vue";
import BarChart from "@c/query-result/bar-chart.vue";
import EditButton from "@c/report-detail/single-blood-oxygen-report/common/edit-button.vue";
import KeyUnitInput from "@c/report-detail/single-blood-oxygen-report/common/key-unit/key-unit-input.vue";
import KeyUnitDatePicker from "@c/report-detail/single-blood-oxygen-report/common/key-unit/key-unit-date-picker.vue";
import { QueryDetailModel } from "./query-detail-model.js";
import appHandler from "@js/appHandler.js";
import { DateTool } from "@/assets/js/date-tool.js";
import dayjs from "dayjs";
export default {
  components: {
    SectionTitle,
    Unit,
    Result,
    QueryTable,
    PsqTable,
    BarChart,
    EditButton,
    KeyUnitInput,
    KeyUnitDatePicker,
  },

  data() {
    return {
      model: undefined,
      showControl: true,
      isEditable: false,
      editableName: undefined,
      editableGender: undefined,
      editableBirthday: undefined,
      editableMedicalRecordNumber: undefined,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  computed: {
    shouldPaging() {
      //EQC和CSHQ问卷的表格/建议太长了，打印效果待后期优化
      // 河南省儿童医院PSQ报告需要图表在第一页，所以不在图表前分页
      if (this.shouldShowMedicalRecord && this.model.type === 13) {
        return false;
      }
      switch (this.model.type) {
        case QUERY_TYPE.PSQ:
        case QUERY_TYPE.OSA_18:
          return true;
        default:
          return false;
      }
    },

    shouldPagingAfterChart() {
      // 河南省儿童医院PSQ报告在图表后分页
      return this.shouldShowMedicalRecord && this.model.type === 13;
    },

    showScore() {
      //河南儿童的饮食问卷没有评分，评分相关需要隐藏
      switch (this.model.type) {
        case QUERY_TYPE.DIET:
          return false
        default:
          return true
      }
    },
    //河南省儿童医院定制
    shouldShowMedicalRecord() {
      return this.model.model.hospitalId === 599;
    },
    
    calculatedAge() {
      if (!this.model || !this.model.model || !this.model.model.birthday) {
        return '';
      }

      return DateTool.calculateAgeWithFullFormat(this.model.model.birthday);
    },

    // 河南省儿童医院 PSQ(13) 或 Conners(16) 问卷的统一判断
    isHenanSpecialType() {
      return this.shouldShowMedicalRecord && (this.model.type === 13 || this.model.type === 16);
    },

    shouldShowEditableFields() {
      return this.isHenanSpecialType;
    },

    shouldShowHospitalLogo() {
      return this.isHenanSpecialType;
    },

    shouldShowBirthday() {
      return this.isHenanSpecialType;
    },

    shouldShowReference() {
      return this.isHenanSpecialType;
    },

    shouldUseTwoColumnTable() {
      // 河南医院所有问卷都使用单列布局，不使用双列
      return false;
    },

    displayTitle() {
      if (this.isHenanSpecialType) {
        if (this.model.type === 16) {
          return '河南省儿童医院(耳鼻喉科)\nConner\'s鼾症儿童行为评估测评报告';
        } else if (this.model.type === 13) {
          return '河南省儿童医院(耳鼻喉科)\nPSQ测评报告';
        }
      }
      return this.model.title;
    },
  },

  async created() {
    const id = this.$router.history.current.query.id;
    this.showControl = this.$router.history.current.query.control != 0;
    this.getAssessmentDetail(id);
  },

  methods: {

    whatOS() {
      let ran = navigator.userAgent
      let isAndroid = ran.indexOf('Android') > -1 || ran.indexOf('Linux') > -1
      let isIOS = !!ran.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isAndroid) {
        return "Android"
      } else if (isIOS) {
        return "IOS"
      } else {
        return "web"
      }
    },
    onDownloadPNG() {
      this.generatePDFAndPNG("PNG");
    },

    onDownloadPDF() {
      this.generatePDFAndPNG("PDF");
    },

    onPrint() {
      if (this.whatOS() == "web") {
        window.print()
      } else {
        this.generatePDFAndPNG('Print')
      }
    },

    async getAssessmentDetail(id) {
      try {
        const rawModel = await this.$api.getAssessmentDetail({ id });
        this.model = new QueryDetailModel(rawModel);
        this.setupEditableData();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    setupEditableData() {
      if (this.model && this.model.model) {
        this.editableName = this.model.name;
        this.editableGender = this.model.sex;
        this.editableBirthday = this.model.model.birthday ? new Date(this.model.model.birthday) : null;
        this.editableMedicalRecordNumber = this.model.medicalRecordNumber;
      }
    },

    onEdit() {
      this.isEditable = true;
    },

    async onSave() {
      try {
        this.validateGender();
        this.validateBirthday();
        this.validateName();
        this.validateMedicalRecordNumber();
        
        await this.saveUserInfo();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async saveUserInfo() {
      // 性别转换：男 -> 1, 女 -> 2
      let sex = null;
      if (this.editableGender === "男") {
        sex = 1;
      } else if (this.editableGender === "女") {
        sex = 2;
      }
      const id = this.$router.history.current.query.id
      
      const params = {
        id, 
        trueName: this.editableName,
        sex: sex,
        birthday: this.editableBirthday ? dayjs(this.editableBirthday).format("YYYY-MM-DD") : null,
        mzh: this.editableMedicalRecordNumber, // 病案号字段名
      };
      
      try {

        await this.$api.editQueryResultUser(params);
        this.isEditable = false;
        this.getAssessmentDetail(this.$router.history.current.query.id);
        this.$toast.showGreen("保存成功");
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    validateName() {
      if (!this.editableName || this.editableName.trim() === '') {
        throw "姓名不能为空";
      }
    },

    validateGender() {
      if (this.editableGender && this.editableGender !== "男" && this.editableGender !== "女") {
        throw "性别只能填男或女";
      }
    },

    validateBirthday() {
      if (this.editableBirthday && !dayjs(this.editableBirthday).isValid()) {
        throw "日期格式错误";
      }
    },

    validateMedicalRecordNumber() {
      if (!this.editableMedicalRecordNumber || this.editableMedicalRecordNumber.trim() === '') {
        throw "病案号不能为空";
      }
    },

    formatBirthday(birthday) {
      return birthday ? dayjs(birthday).format('YYYY年MM月DD日') : '';
    },

    getPsqTotalScore() {
      // 从model中获取PSQ总分
      return this.model.totalScore || this.model.score || 0;
    },

    async generatePDFAndPNG(downloadType) {
      try {
        const id = this.$router.history.current.query.id;
        const data = await this.$api.generatePDFAndPNG({ id });
        switch (downloadType) {
          case 'PDF':
            if (this.whatOS() == "web") {
              window.location.href = data.pdfUrl
              console.log(window.location.href)
            } else {
              appHandler.sendMsg({
                type: "DownloadPDF",
                pngUrl: data.pngUrl,
                pdfUrl: data.pdfUrl
              })
            }
            break;
          case 'PNG':
            if (this.whatOS() == "web") {
              window.location.href = data.pngUrl
            } else {
              appHandler.sendMsg({
                type: "DownloadPNG",
                pngUrl: data.pngUrl,
                pdfUrl: data.pdfUrl
              })
            }
            break;
          case 'Print':
            appHandler.sendMsg({
              type: "Print",
              pngUrl: data.pngUrl,
              pdfUrl: data.pdfUrl
            })
            break;
          default:
            break;
        }
      } catch (error) {
        this.$toast.showRed(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .noPrint {
    display: none;
    background-color: white !important;
  }

  .query-result {
    &-content {
      margin: 0 !important;
    }
  }
}

.query-result {
  background-color: white;

  &-content {
    left: top;
    width: rem(700);
    margin: 24px auto 0;
    position: relative;
    min-height: calc(100vh - 48px);

    &-top {
      width: 100%;
      display: flex;
      flex-direction: column;

      &-header {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        position: relative;
        width: 100%;
        
        &.with-logo {
          min-height: 80px;
        }
      }

      &-title {
        color: black;
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        white-space: pre-line;
        text-align: center;
        width: 100%;

        &.title-small {
          font-size: 18px;
          line-height: 26px;
        }
      }
      
      &-header.with-logo &-title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
      }
      
      &-header:not(.with-logo) &-title {
        align-self: center;
      }

      &-buttons {
        // font-size: 16px;
        align-self: flex-end;
        display: flex;
        margin-right: 10px;
        margin-top: 10px;

        >button {
          color: white;
          background-color: #325fac;
          font-size: rem(12);
          border-radius: rem(4);
          width: rem(58);
          height: rem(25);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: rem(8);
        }

        .edit-button-top {
          ::v-deep(.edit-button) {
            font-size: rem(12);
            border-radius: rem(4);
            width: rem(58);
            height: rem(25);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: rem(8);
            border: none;
            cursor: pointer;
            
            &.edit {
              color: white;
              background-color: #325fac;
            }
            
            &.save {
              color: white;
              background-color: #67c23a;
            }
          }
        }
      }
    }

    &-bar-chart {
      margin-top: 20px;
    }

    &-basis {
      width: 100%;
      padding: 15px 0;
      display: flex;
      justify-content: space-between;
    }
    &-basis-mr {
      padding: 5px 0;
    }

    &-suggestion {
      color: black;
      font-size: 16px;
      line-height: 24px;
      white-space: pre-line;
      width: 100%;
      padding: 12px 0;
    }

    &-footer {
      width: 100%;
      padding: 5px 0;
      border-top: 1px solid #eeeeee;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      p {
        color: black;
        font-size: 16px;
        line-height: 24px;
        text-align: left;
        margin: 0;
        flex: 0 0 auto;
      }
    }

    &-reference {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      
      p {
        color: #999;
        font-size: 12px;
        margin: 0;
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    box-sizing: border-box;
    &-content {
    width: calc(100% - 20px);
     padding: 10px;
    }
  }
}

.query-result-599 {
  ::v-deep(.section-title) {
    height: 35px;
  }
  ::v-deep(.result) {
    padding: 10px 0;
  }
}

.query-result-henan-special {
  ::v-deep(.section-title-title) {
    font-size: 14px;
  }

  // 基本信息、评估结果下的内容字体 12px
  ::v-deep(.unit) {
    font-size: 12px;
    line-height: 20px;
  }

  // 指导意见内容字体 12px
  .query-result-content-suggestion {
    font-size: 12px;
    line-height: 20px;

    // PSQ(type=13)专用，line-height 更小
    &.psq-suggestion {
      line-height: 10px;
    }
  }

  // 科室、报告医生、日期字体 12px
  .query-result-content-footer p {
    font-size: 12px;
    line-height: 20px;
  }

  // PSQ表格字体 12px，margin 减小
  ::v-deep(.psq-table) {
    margin: 0;

    th, td {
      font-size: 12px;
    }
  }

  // QueryTable表格字体 12px
  ::v-deep(.query-table) {
    .el-table th.el-table__cell > .cell,
    .el-table--enable-row-transition .el-table__body td.el-table__cell {
      font-size: 12px;
    }
  }

  // 基本信息区域间距减小
  .query-result-content-basis {
    padding: 2px 0;
  }

  @media print {
    .query-result-content-top {
      margin-bottom: 0;

      &-header.with-logo {
        min-height: 60px;
      }

      &-buttons {
        display: none !important;
        height: 0;
        margin: 0;
        overflow: hidden;
      }
    }
  }
}


.query-result-content-editable {
  width: 100%;
  padding: 15px 0;

  &-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ::v-deep(.key-unit) {
    margin-right: 20px;
    width: 180px;
    
    .key-unit-key {
      min-width: 90px !important;
      color: black;
    }
  }

  ::v-deep(.key-unit-input),
  ::v-deep(.key-unit-date-picker) {
    width: 180px;
  }

  .key-unit.gender-select-unit {
    width: 180px;
    display: flex;
    align-items: center;
    
    .key-unit-key {
      font-size: 16px;
      color: #000;
      min-width: 90px;
      margin: 0;
      padding: 0;
    }
    
    .key-unit-content {
      flex: 1;
      
      .el-select {
        width: 100%;
      }
    }
  }

  .medical-record-input {
    width: 250px !important;
  }
}

.hospital-logo {
  width: 120px;
  height: auto;
  margin-right: 20px;
}
</style>
